import React from 'react';
import './Bottomrectangle.css'; // Optional: add styles here

function Bottomrectangle
() {
  return <div className='rectangle2'></div>
}

export default Bottomrectangle
;
